// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ElbowIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 8 8">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M.67 0C.3 0 0 .3 0 .67V7a1 1 0 0 0 1 1h6.33a.67.67 0 0 0 0-1.33h-5a1 1 0 0 1-1-1v-5C1.33.3 1.03 0 .67 0"
      clipRule="evenodd"
    />
  </svg>,
  "Elbow",
);
export default ElbowIcon;
